<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>用户管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>用户课程管理列表</span>
        </div>
        <!-- <div style="display: flex">
          <el-button @click="selectCourse()" size="small" icon="el-icon-plus" type="success">添加课程</el-button>
          <el-button @click="back()" size="small" icon="el-icon-back" type="primary">返回列表</el-button>
        </div> -->
      </div>
      <div class="search-box">
        <el-form :inline="true" label-width="120px">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item prop="column_ary">
            <el-cascader :props="{label: 'title','value':'id'}" v-model="search.column_ary" :options="LmColumn"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe size="small" style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="id" label="UID" width="80"></el-table-column>
          <el-table-column align="center" prop="column_name" label="科目" width="220"></el-table-column>
          <el-table-column prop="title" label="课程名称" width="*"></el-table-column>
          <el-table-column align="center" width="120" label="价格">
            <template #default="scope">
              <el-tag type="success">{{ scope.row.price }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" width="120" label="资料">
            <template #default="scope">
              <el-tag type="warning">{{ scope.row.download }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" width="120" label="课时">
            <template #default="scope">
              <el-tag type="danger">{{ scope.row.total }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" width="120" label="状态">
            <template #default="scope">
              <el-tag effect="dark" type="success" v-if="scope.row.status">正常</el-tag>
              <el-tag effect="dark" type="danger" v-else>下架</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="created_at" width="160" label="添加时间"></el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total, prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      LmColumn: [],
      search: {
        keys: "",
        column_ary: [],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getCate();
  },
  methods: {
    getCate() {
      var that = this;
      that.axios.post("/getColumnCate").then((res) => {
        if (res) {
          that.LmColumn = res.data;
        }
        that.loading = false;
      });
    },

    getIndex() {
      var that = this;
      that.getList();
    },

    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getList();
    },

    handleCurrentChangeGrid(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("确认取消此课程吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios.post("/setCancelCourse", { id: ids }).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keyword = that.search.keys;
      formData.columns = that.search.column_ary;
      that.axios.post("/getPageCourse", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/users/index");
    },
  },
};
</script>
<style>
</style>